import { render, staticRenderFns } from "./plateNumber.vue?vue&type=template&id=0f9554d0&scoped=true"
import script from "./plateNumber.vue?vue&type=script&lang=js"
export * from "./plateNumber.vue?vue&type=script&lang=js"
import style0 from "./plateNumber.vue?vue&type=style&index=0&id=0f9554d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9554d0",
  null
  
)

export default component.exports